import type { ReactElement } from 'react';
import type { AgGridType } from '@common';

export function SerialNumberCellRenderer(params: AgGridType.ICellRendererParams): ReactElement {
  return (
    <>{params.node?.rowIndex == null ? '' : params.node.rowIndex + 1}</>
  );
}
